import React, { useState } from 'react';
import CarRegistrationForm from '../CarRegistrationForm/CarRegistrationForm';
import withDataCheck, { withDataCheckProps } from '../../hoc/withDataCheck/withDataCheck';
import { Container, Row, Col } from 'react-bootstrap';
import CheckResult from '../CheckResult/CheckResult';
import './VignetteCheck.scss';

import { useTranslation } from 'react-i18next';

/**
 * Component/Page for checking validity of a vignette
 *
 * @component - VignetteCheck
 * @parentComponent - App
 */

interface Props extends withDataCheckProps {}

const VignetteCheck = (props: Props) => {
  const { t } = useTranslation();

  const [isDirty, changeDirtyState] = useState(true);

  function clearDirtyState() {
    changeDirtyState(false);
  }

  function setDirtyState() {
    changeDirtyState(true);
  }

  return (
    <div className="VignetteCheck">
      <Container>
        <Row>
          <Col>
            <h1 className="heading">{t('VignetteCheck.heading')}</h1>
          </Col>
        </Row>
      </Container>
      <CarRegistrationForm
        dataCheck={props.configureDataCheck('check/vignette')}
        clearDirtyState={clearDirtyState}
        setDirtyState={setDirtyState}
        setPersonalNumberInput={false}
      />
      <CheckResult data={props} type={'vignette'} isDirty={isDirty} />
    </div>
  );
};

export default withDataCheck(VignetteCheck);
